"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _groupList = _interopRequireDefault(require("./group-list"));
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-cjiy8xj",
  vars: {
    "cjiy8xj-1": [({
      col
    }) => `repeat(${col}, 1fr)`],
    "cjiy8xj-3": [({
      applyInnerSpacing
    }) => applyInnerSpacing ? 'var(--viewport-space--300)' : '0'],
    "cjiy8xj-5": [({
      applyInnerSpacing
    }) => applyInnerSpacing ? 'auto' : 'initial'],
    "cjiy8xj-7": [({
      applyInnerSpacing
    }) => applyInnerSpacing ? `${_patternLibraryUtils.size.laptopLg}px` : 'revert']
  }
});
const ListSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "ListSection",
  class: "pl-l99zvya",
  vars: {
    "l99zvya-0": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : _intents.default.ux.box.backgroundColor]
  }
});

/**
 * LongTextList Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking Name of the component
 * @param {Array} props.items List of items to display
 * @param {string} props.backgroundColor Background Color object
 * @param {boolean} props.invert Invert foreground color
 * @param {string} props.verticalMargin Vertical Outer Spacing value
 * @param {string} props.verticalPadding Vertical Inner Spacing value
 * @param {boolean} props.applyInnerSpacing Applies Horizontal Inner Spacing and max-width
 * @param {String} props.partial Theme partial
 * @returns {React.ReactElement} LongTextList Component
 * @public
 */

function LongTextList({
  _name,
  items,
  inverted = false,
  partial,
  backgroundColor,
  verticalMargin = 'small',
  verticalPadding = 'none',
  applyInnerSpacing = false
}) {
  const bgColor = (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor);
  return /*#__PURE__*/_react.default.createElement(ListSection, {
    _name: _name,
    dataCy: "long-text-list",
    partial: partial || (inverted ? 'dark1' : ''),
    backgroundColor: bgColor,
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding
  }, /*#__PURE__*/_react.default.createElement(Container, {
    col: items?.length,
    applyInnerSpacing: applyInnerSpacing
  }, items?.slice(0, 3).map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(_groupList.default, (0, _extends2.default)({
      key: idx
    }, item, {
      partial: partial || (inverted ? 'dark1' : '')
    }));
  })));
}
var _default = exports.default = LongTextList;
LongTextList.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.array,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  inverted: _propTypes.default.bool,
  partial: _propTypes.default.string,
  applyInnerSpacing: _propTypes.default.bool,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};